<div class="row">
    <div class="col-6">
        <div class="form-field">
            <input #searchInput class="form-control"
                   [placeholder]="'bcContestCourse_search' | translate"
                   (input)="filter(searchInput.value)">
        </div>
    </div>
</div>

<app-table [rows]="items" [columns]="columns" sticky="right">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>{{row.Code}}</td>
            <td>
                {{row.Name + (row.GroupName ? ' - ' + row.GroupName : '')}}
            </td>
            <td>{{row.PlanningPeriod}}</td>
            <td>{{row.StudyProgram}}</td>
            <td>{{row.GroupMaxSize}}</td>
            <td>{{row.ApplicationCount}}</td>
            <td>{{row.InApplicationCount}}</td>
            <td>
                <div class="table-actions">
                    <button type="button" class="btn btn-outline btn-icon" [ngbTooltip]="'bcContest_applications' | translate" (click)="openApplications(row)">
                        <i class="fi fi-rs-apps"></i>
                    </button>
                </div>
            </td>
        </tr>
    </ng-template>
</app-table>
